import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import ProductCard from '@nmx/template/dist/componentLibrary/modules/ProductCard';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import EnvelopeWithPaperMoney from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/EnvelopeWithPaperMoney';
import Clock from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/Clock';
// styles
import {
  ColStyled,
  ColStyledButtonContainer,
  RowStyled,
} from './styles';

export default () => (
  <SectionContainer
    id='income-annuities-product-callout-grouping'
    backgroundVariant='lightB'
    themeType='lightTheme'
    moduleName='product-callout-grouping-module'
    moduleVariation='A'>
    <Row align='center'>
      <Typography
        align='center'
        component='h2'
        nextElement='graphic'>
        What are the types of <WidowBlock>income annuities&#63;</WidowBlock>
      </Typography>
    </Row>
    <RowStyled align='center'>
      <ColStyled
        medium={6}
        large={5}>
        <ProductCard
          icon={EnvelopeWithPaperMoney}
          backgroundVariant='lightA'
          cardId='product-callout-income-annuities-immediate-income-card'
          cardHeading='Immediate Income Annuities'
          cardText='An immediate income annuity is best for someone who is very close to retiring, as it gives you a guaranteed stream of income that starts within one year of purchase and continues for the rest of your life.'
        />
      </ColStyled>
      <Col
        medium={6}
        large={5}>
        <ProductCard
          icon={Clock}
          backgroundVariant='lightA'
          cardId='product-callout-income-annuities-deferred-income-card'
          cardHeading='Deferred Income Annuities'
          cardText='A deferred income annuity lets you set aside a portion of your savings today to create income for your retirement. The earlier you buy one, the higher your income payments will be down the road.'
        />
      </Col>
    </RowStyled>
    <Row align='center'>
      <ColStyledButtonContainer>
        <Link
          id='product-callout-income-annuities-compare-annuities-link'
          variant='buttonLinkSecondary'
          linkUrl='#income-annuities-product-comparison-chart-section-container'>
          Compare annuities
        </Link>
      </ColStyledButtonContainer>
    </Row>
  </SectionContainer>
);
